import initPayment from './initPayment'

export const initPaymentService = initPayment
